
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PaymentModeDialog extends Serenity.EntityDialog<PaymentModeRow, any> {
        protected getFormKey() { return PaymentModeForm.formKey; }
        protected getIdProperty() { return PaymentModeRow.idProperty; }
        protected getLocalTextPrefix() { return PaymentModeRow.localTextPrefix; }
        protected getNameProperty() { return PaymentModeRow.nameProperty; }
        protected getService() { return PaymentModeService.baseUrl; }
        protected getDeletePermission() { return PaymentModeRow.deletePermission; }
        protected getInsertPermission() { return PaymentModeRow.insertPermission; }
        protected getUpdatePermission() { return PaymentModeRow.updatePermission; }

        protected form = new PaymentModeForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.CommissionPercent);
            this.form.Type.changeSelect2(e => {
                if (this.form.Type.value == "280") {
                    this.form.LedgerId.cascadeField = "AccountGroupId";
                    this.form.LedgerId.cascadeValue = "37";
                }
                else if (this.form.Type.value == "281") {

                }
                else if (this.form.Type.value == "282") {

                }
                else if (this.form.Type.value == "283") {

                }
                else if (this.form.Type.value == "284") {

                }
                else if (this.form.Type.value == "285") {
                    this.form.LedgerId.cascadeField = "AccountGroupId";
                    this.form.LedgerId.cascadeValue = "38";
                }
                else if (this.form.Type.value == "286") {

                }
                else if (this.form.Type.value == "287") {

                }
            });
        }
    }
}